import LeadsContainer from './Leads.container'
export default LeadsContainer



// WEBPACK FOOTER //
// ./src/pages/leads/index.js